/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Asset {
  id?: number;
  stage?: Asset.StageEnum;
  stageBeforeRequest?: Asset.StageBeforeRequestEnum;
  code?: string;
  name?: string;
  qtyScale?: number;
  refPriceUsd?: number;
  fiat?: boolean;
  manualRate?: boolean;
}
export namespace Asset {
  export const StageEnum = {
    Active: 'ACTIVE',
    Disabled: 'DISABLED',
    DeactivationRequested: 'DEACTIVATION_REQUESTED',
    Deactivating: 'DEACTIVATING',
    Deactivated: 'DEACTIVATED',
  } as const;
  export type StageEnum = (typeof StageEnum)[keyof typeof StageEnum];
  export const StageBeforeRequestEnum = {
    Active: 'ACTIVE',
    Disabled: 'DISABLED',
    DeactivationRequested: 'DEACTIVATION_REQUESTED',
    Deactivating: 'DEACTIVATING',
    Deactivated: 'DEACTIVATED',
  } as const;
  export type StageBeforeRequestEnum = (typeof StageBeforeRequestEnum)[keyof typeof StageBeforeRequestEnum];
}
